import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store'

Vue.use(VueI18n)
function checkLang() {
  let lang = localStorage.getItem('lang')
  let locale = 'en_us'
  if(lang) {
    if(lang == 1) {
      locale = 'zh_cn'
    } else if (lang == 2) {
      locale = 'en_us'
    } else {
      locale = 'fr_fr'
    }
    return locale;
  }
  return locale;

}
const i18n = new VueI18n({
  locale:  checkLang() || 'zh_cn',
  messages: {
    'en_us': {},
    'zh_cn': {},
    'fr_fr': {}
  },
  silentTranslationWarn:true
})
export default i18n;



// WEBPACK FOOTER //
// ./src/plugins/i18n.js